module.exports = __webpack_public_path__ + "img/user-head-man.79c8d87c.jpg";